export default __webpack_public_path__ + "static/media/bubble_nova_xl3.ab444cca.png";